module.exports = __webpack_public_path__ + "img/Misi2-3-3Judul.da116a89.png";